import { ref, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export function useActiveEvents(props) {
  const store = useStore();
  const route = useRoute();

  const filterDictionary = reactive({
    eventTypeNames: [],
    eventCategoryNames: [],
  });
  const selectedActiveEvent = ref(null);

  const childFacilityMap = computed(() => {
    const map = new Map();
    const struct = store.getters.struct || [];
    for (const element of struct) {
      const facilityId = element.facility_id;
      if (!element.children) continue;
      for (const child of element.children) {
        const key = `${facilityId}|${child.parent_flange_no_min}`;
        map.set(key, child);
      }
    }
    return map;
  });

  const getChildFacility = (facilityId, flangeNo, name) => {
    const key = `${facilityId}|${flangeNo}`;
    const child = childFacilityMap.value.get(key);
    return child ? child[name] : null;
  };

  const activeEvents = computed(() => {
    const result = [];
    const facilityId = Number(route.params.facility_id);
    const checkFacilityId = facilityId > 0 && props.checkFacilityId;
    const monitoringStruct = store.getters.monitoringStruct || [];

    for (const monitoring of monitoringStruct) {
      const hasEvents = monitoring.eventList?.length;
      if (!hasEvents) continue;
      const matchesFacility = !checkFacilityId || monitoring.facilityMonitoringId === facilityId;
      if (!matchesFacility) continue;

      for (const event of monitoring.eventList) {
        const wellName = getChildFacility(event.facilityId, event.flangeNo, 'facility_name');
        result.push({
          id: event.id,
          propertyId: event.propertyId,
          facilityId: event.facilityId,
          event_group_index: event?.eventType?.groupId ? event.eventType.groupId - 1 : null,
          date: event.date ? new Date(event.date) : null,
          flangeNo: event.flangeNo,
          facilityName: monitoring.facilityMonitoringName,
          eventTypeName: event?.eventType?.name,
          eventCategoryName: event?.eventType?.eventCategory?.name,
          shouldPlaySound: event?.soundInfo?.shouldPlaySound,
          textForSoundReproduction: event?.soundInfo?.textForSoundReproduction,
          propertyDesc: event?.propertyDesc,
          wellName: wellName || monitoring.facilityMonitoringName,
        });
      }
    }
    return result;
  });

  const updateUniqueValues = (events) => {
    const eventTypeMap = new Map();
    const eventCategoryMap = new Map();

    events.forEach((event) => {
      if (event.eventTypeName) {
        eventTypeMap.set(event.eventTypeName, { eventTypeName: event.eventTypeName });
      }
      if (event.eventCategoryName) {
        eventCategoryMap.set(event.eventCategoryName, { eventCategoryName: event.eventCategoryName });
      }
    });

    filterDictionary.eventTypeNames = Array.from(eventTypeMap.values()).sort((a, b) =>
      a.eventTypeName.localeCompare(b.eventTypeName)
    );
    filterDictionary.eventCategoryNames = Array.from(eventCategoryMap.values()).sort((a, b) =>
      a.eventCategoryName.localeCompare(b.eventCategoryName)
    );
  };

  watch(
    activeEvents,
    (newEvents) => {
      updateUniqueValues(newEvents);
    },
    { immediate: true }
  );

  return {
    activeEvents,
    filterDictionary,
    selectedActiveEvent,
    updateUniqueValues,
  };
}